import { ErrorBoundary } from '../components/ErrorBoundary'
import { SearchWidget } from '../components/SearchWidget'
import { DifferenceBanner, CommandCenter, MarketPulse } from '../components/CommandCenter'
import { NextStep, CreateRolePipeline } from '../components/NextStep'
import { RecommendedExecutives } from '../components/RecommendedExecutives'
import { RecentlyViewed } from '../components/RecentlyViewed'
import { DecisionDocumentation } from '../components/DecisionDocumentation'
import { SavedSearches, PipelineByRole } from '../components/Tables'
import { ActiveEngagements } from '../components/ActiveEngagements'
import { LowerGrid } from '../components/LowerGrid'

/**
 * The Home dashboard, in the order of the locked reference.
 *
 * Each section is boundaried separately: one widget throwing should cost that
 * widget, not the page. A blank dashboard reads as "no candidates", which is
 * a materially different message from "this failed to load".
 */
const SECTIONS: Array<[string, React.ComponentType]> = [
  ['NexExec Difference', DifferenceBanner],
  ['Search', SearchWidget],
  ['Hiring Command Center', CommandCenter],
  ['Recommended Next Step', NextStep],
  ['Create a Role Pipeline', CreateRolePipeline],
  ['Recommended Executives', RecommendedExecutives],
  ['Saved Searches', SavedSearches],
  ['Hiring Pipeline by Role', PipelineByRole],
  ['Recently Viewed', RecentlyViewed],
  ['Active Conversations', ActiveEngagements],
  ['Decision Documentation', DecisionDocumentation],
  ['Market Pulse', MarketPulse],
  ['Team Activity', LowerGrid],
]

export function Dashboard() {
  return (
    <>
      {SECTIONS.map(([name, Section]) => (
        <ErrorBoundary key={name} section={name}>
          <Section />
        </ErrorBoundary>
      ))}
    </>
  )
}
